<div class="header">
  <div class="header-actions" *ngIf="!disabled">
    <h4>{{ 'brand.prepTime.itemPrepGroups' | translate }}</h4>
  </div>
</div>

<div class="form-content" [formGroup]="form">
  <table mat-table
         [dataSource]="dataSource"
         matSort
         matSortActive="groupName"
         matSortDirection="asc"
         matSortDisableClear>
    <ng-container matColumnDef="groupName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'store.dynamicPrepTime.groupName' | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <a class="edit-link"
           (click)="onEditGroup(group)"
           [attr.title]="'form.button.edit' | translate"
           data-qa-label="EditLink">
          {{ group.name }} [{{ group.items.length }}]
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="rangeStart">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'store.dynamicPrepTime.rangeStart' | translate }}
      </th>
      <td mat-cell *matCellDef="let group; let i = index;">
        <mat-form-field class="range-start" [formGroup]="$any(form.get('groups')['controls'][i])">
          <mat-label>{{ 'store.dynamicPrepTime.rangeStart' | translate }}</mat-label>
          <input matInput
                 txpIntegersOnly
                 min="0"
                 required
                 data-qa-label="RangeStart"
                 formControlName="rangeStart">
          <mat-error>
            {{ 'form.error.required' | translate}}
          </mat-error>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="rangeEnd">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'store.dynamicPrepTime.rangeEnd' | translate }}
      </th>
      <td mat-cell *matCellDef="let group; let i = index;">
        <mat-form-field class="range-start" [formGroup]="getGroupForm(i)">
          <mat-label>{{ 'store.dynamicPrepTime.rangeEnd' | translate }}</mat-label>
          <input matInput
                 txpIntegersOnly
                 min="0"
                 required
                 data-qa-label="RangeEnd"
                 formControlName="rangeEnd">
          <mat-error *ngIf="getGroupForm(i).get('rangeEnd').errors?.required">
            {{ 'form.error.required' | translate}}
          </mat-error>
          <mat-error *ngIf="getGroupForm(i).get('rangeEnd').errors?.greaterThan">
            {{ 'store.dynamicPrepTime.startGreaterThanEnd' | translate}}
          </mat-error>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="prepTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'store.dynamicPrepTime.prepTime' | translate }}
      </th>
      <td mat-cell *matCellDef="let group; let i = index;">
        <mat-form-field class="range-start" [formGroup]="$any(form.get('groups')['controls'][i])">
          <mat-label>{{ 'store.dynamicPrepTime.prepTime' | translate }}</mat-label>
          <input matInput
                 txpIntegersOnly
                 required
                 data-qa-label="PrepTime"
                 formControlName="prepTime">
          <mat-error>
            {{ 'form.error.required' | translate}}
          </mat-error>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef >
        {{ 'store.dynamicPrepTime.action' | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <ng-container>
          <div class="row-actions">
            <txp-button data-qa-label="RemoveButton"
                        [style]="buttonStyle.ROWACTION"
                        icon="tce-icon-trash"
                        [attr.title]="'form.button.remove' | translate"
                        (click)="deletePrepGroup(group)">
            </txp-button>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
  </table>
  <txp-button data-qa-label="NewGroupButton"
              class="new-group-btn"
              [style]="buttonStyle.SECONDARY"
              (click)="onCreateNewGroup()">
    {{ 'store.dynamicPrepTime.newGroup' | translate }}
  </txp-button>
</div>

